import { API_BASE_URL } from '../config';

// Authenticated /webforms/** API: leads submitted through the public website
// (contact form + song requests). kind is 'contact' or 'songs'.
export const PAGE_SIZE = 50;

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

const check = (response, what) => {
  if (!response.ok) {
    throw new Error(`${what} failed (${response.status})`);
  }
  return response;
};

// DJB-265: `date` (yyyy-MM-dd, a Brussels day) narrows the list to one day
// of the day summary; without it the list is unfiltered as before
export const listRequests = async (kind, status, page, token, { date } = {}) => {
  const dateParam = date ? `&date=${encodeURIComponent(date)}` : '';
  const response = await fetch(
    `${API_BASE_URL}/webforms/${kind}?status=${status}&page=${page}&size=${PAGE_SIZE}${dateParam}`,
    { headers: authHeaders(token) }
  );
  return (await check(response, 'Loading requests').json());
};

// DJB-265: per-day summary [{ date: 'yyyy-MM-dd', open, completed }], newest
// first, behind the day headers of the inbox lists
export const fetchDays = async (kind, token) => {
  const response = await fetch(`${API_BASE_URL}/webforms/${kind}/days`, { headers: authHeaders(token) });
  return (await check(response, 'Loading days').json());
};

export const fetchCounts = async (token) => {
  const response = await fetch(`${API_BASE_URL}/webforms/counts`, { headers: authHeaders(token) });
  return (await check(response, 'Loading counts').json());
};

export const setHandled = async (kind, id, handled, token) => {
  const response = await fetch(
    `${API_BASE_URL}/webforms/${kind}/${encodeURIComponent(id)}/handled`,
    {
      method: 'PUT',
      headers: { ...authHeaders(token), 'Content-Type': 'application/json' },
      body: JSON.stringify({ handled }),
    }
  );
  check(response, 'Updating request');
};

export const deleteRequest = async (kind, id, token) => {
  const response = await fetch(`${API_BASE_URL}/webforms/${kind}/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: authHeaders(token),
  });
  check(response, 'Deleting request');
};
